import React, { FC } from 'react';
import { ScoreBar } from './LegendScoreBar.styles';
import { THEME as theme } from '../../styles/theme';

interface ILegendScoreBar {
  score: string
}

enum LegendScore {
  WEAK = 'weak',
  NORMAL = 'normal',
  STRONG = 'strong',
  HIGH = 'high',
  POTENTIAL = 'potential',
  LOW = 'low',
  SHOULD = 'should',
  COULD = 'could',
  EXCEL = 'excel',
  OTHER = 'other',
}

const chooseColor = (score: string) => {
  switch(score){
    case LegendScore.WEAK:
    case LegendScore.SHOULD:
    case LegendScore.HIGH:
      return theme.colors.accent.red[100];
    case LegendScore.NORMAL:
      return theme.colors.accent.blue[100];
    case LegendScore.STRONG:
    case LegendScore.EXCEL:
    case LegendScore.LOW:
      return theme.colors.accent.green[100];
    case LegendScore.POTENTIAL:
    case LegendScore.OTHER:
    case LegendScore.COULD:
      return theme.colors.accent.orange[100];
    default:
      return theme.colors.accent.red[100];
  }
};

const LegendScoreBar: FC<ILegendScoreBar> = ({score}) => {
  const background = chooseColor(score);
  return <ScoreBar id="ScoreBar" data-testid="scoreBar" background={background}/>;
};

export default LegendScoreBar;
